(function($){

  $(document).ready(function() {
    // console.log($('.single-product select'))
    $('.single-product select').select2({
      minimumResultsForSearch: Infinity,
      dropdownParent: $('.variations')
    });
  });

})(jQuery)